import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
                light: {
                primary: '#1a3765',
                secondary: '#0D7CC4',
                accent: '#8c9eff',
                error: '#b71c1c',
                gold : '#9c6b00',
                customPageBg: '#1950A4',
            },
        },
    },
});
